import moment from "moment";
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import MultiSelectComponent from "../../../components/multi-select/multi-select.component";
import { formats } from "../../../config/constants";
import FileContentModel from '../../../models/monitoring-report/file-content.model';
import ViewBase from "../../view-base.view";
import MonitoringReportFileContentDetailComponent from "./monitoring-report-file-content-detail.component";
import { Tooltip, PopoverPosition } from "construct-ui";

/**
 * Monitoring Report - File Content
 * 
 * 
 * 
 * @author cmc.nttruong1
 */

export default function MonitoringReportFileContentView() {
  ViewBase.call(this);

  const DEFAULT_FILTERS = {
    customer: [],
    fileType: [],
    dateFrom: moment().format(formats.dateFormat),
    dateTo: moment().format(formats.dateFormat),
  };

  const DEFAULT_TOTAL_RESULT = {
    totalFiles: 0,
    successRate: 0,
    records: 0,
    success: 0,
    processed: 0,
    errors: 0,
  }

  const EXPORT_TYPE = {
    SUMMARY: 0,
    RAW: 1,
    SALES_DATE_IMEI: 2,
  }


  const BG_COLOR_FOOT = 'var(--bs-gray-400)';
  const FORM_ID = 'sectionFilter';
  // const BOOTSTRAP_INVALID_CLASS = 'is-invalid';
  const PROCESS_DATE_ID = 'processDate';
  const LIMIT_DATE = 62;

  let filters = structuredClone(DEFAULT_FILTERS);
  let totalResult = structuredClone(DEFAULT_TOTAL_RESULT);
  let listReport = [];
  let customerOptions = [];
  let fileTypeOptions = [];
  let errorMessage = '';
  let currentFilters = {};

  const getListCustomer = () => {
    customerOptions.splice(0);
    FileContentModel.getListIntfEdiCustomers()
      .then((result) => {
        result?.map(i => customerOptions.push({ ...i }))
      })
      .catch((error) => {
        customerOptions.splice(0);
        this.handleError(error);
      });
  }

  const getListFileType = () => {
    fileTypeOptions.splice(0);
    FileContentModel.getListIntfEdiFileType()
      .then((result) => {
        result?.map(i => fileTypeOptions.push({ ...i }))
      })
      .catch((error) => {
        fileTypeOptions.splice(0);
        this.handleError(error);
      })
  }

  const formatToPercentNumber = (num) => {
    return Math.round(num * 100 * 100) / 100;
  }

  const formatParams = () => {
    return Object.assign({
      clientCode: filters.customer?.map(i => i.code),
      fileType: filters.fileType?.map(i => i.code),
      fromDate: filters.dateFrom,
      toDate: filters.dateTo,
    })
  }

  const handleClickSearch = () => {
    let payload = formatParams();
    currentFilters = structuredClone(payload);
    listReport.splice(0);
    totalResult = structuredClone(DEFAULT_TOTAL_RESULT);
    search(currentFilters);
  }

  const search = (payload) => {
    this.showLoading();

    FileContentModel.searchContentReport(payload)
      .then((result) => {
        result.listReport?.filter((i) => {
          if (i.clientCode) {
            listReport.push({ ...i });
          }
        });

        listReport.map(i => {
          totalResult.totalFiles += i.totalFiles;
          totalResult.successRate += (i.success / i.records);
          totalResult.records += i.records;
          totalResult.success += i.success;
          totalResult.processed += i.processed;
          totalResult.errors += i.errors;
        });
        totalResult.successRate = formatToPercentNumber(totalResult.successRate / listReport.length) || 0;
      })
      .catch((error) => {
        listReport.splice(0);
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() })
  }

  const handleClickClear = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    // totalResult = structuredClone(DEFAULT_TOTAL_RESULT);
  }


  const exportSummary = (payload) => {
    FileContentModel.exportSummaryData(payload)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const exportRaw = (payload) => {
    FileContentModel.exportRawData(payload)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const exportSaleDateImei = (payload) => {
    FileContentModel.exportSaleDateVsImei(payload)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  // Placed here because export functions are variables and they have to exists before variable declaration
  const callExportFunction = [exportSummary, exportRaw, exportSaleDateImei];

  const handleClickDownload = (index) => {
    this.showLoading();

    switch (index) {
      case EXPORT_TYPE.RAW: // RAW DATA EXPORT need STATUS attribute
        currentFilters['status'] = '';
        break;
      case EXPORT_TYPE.SALES_DATE_IMEI: // SALES DATE IMEI EXPORT procedured use between => string to int
        currentFilters.toDate = currentFilters.toDate.replaceAll('.', '');
        currentFilters.fromDate = currentFilters.fromDate.replaceAll('.', '');
        break;
    }

    callExportFunction[index](currentFilters);
  }

  return {
    oninit: () => {
      getListCustomer();
      getListFileType();
    },
    view: () => {
      return [
        /* SEARCH */
        m('.card.mb-3',
          m('.card-body',
            m('form.row.g-2',
              { id: FORM_ID },
              m('.col-xl-3.col-lg-4.col-sm-6',
                m('label.form-label[for=customer]', this.getText('LT00008046', 'Customer')),
                m(MultiSelectComponent, {
                  id: 'customer',
                  items: customerOptions,
                  selectedItems: filters.customer,
                  onSelect: (value) => {
                    filters.customer = value;
                  }
                }),
              ),
              m('.col-xl-3.col-lg-4.col-sm-6',
                m('label.form-label[for=fileType]', this.getText('LT00008055', 'File Type')),
                m(MultiSelectComponent, {
                  id: 'fileType',
                  items: fileTypeOptions,
                  selectedItems: filters.fileType,
                  onSelect: (value) => {
                    filters.fileType = value;
                  }
                }),
              ),
              m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                m(`label.form-label[for=${PROCESS_DATE_ID}]`, this.getText('LT00008056', 'Process Date'), m(Tooltip, {
                  content: m('span', "Maximum selectable period: 2 months"),
                  hoverOpenDelay: 250,
                  openOnTriggerFocus: true,
                  position: PopoverPosition.AUTO,
                  trigger: m('i.bi.bi-info-circle.cursor-pointer.ps-1.me-0', { style: { 'color': '#FF9800' } })
                })),
                m('div', { id: PROCESS_DATE_ID, },
                  m(DatePickerComponent, {
                    class: 'form-control',
                    readonly: true,
                    isRange: true,
                    required: true,
                    maxDays: LIMIT_DATE,
                    dateStart: filters.dateFrom,
                    dateEnd: filters.dateTo,
                    onselect: (e) => {
                      filters.dateFrom = moment(e.detail.start).format(formats.dateFormat);
                      filters.dateTo = moment(e.detail.end).format(formats.dateFormat);
                    }
                  }),
                ),
                m('.invalid-tooltip', errorMessage)
              ),

              // Search & clear buttons
              m('.col-12.d-flex.justify-content-end.gap-2',
                m('button.btn.btn-primary[type=button]',
                  {
                    onclick: handleClickSearch,
                  },
                  this.getText("LT00000001", "Search")
                ),
                m('button.btn.btn-white[type=button]',
                  { onclick: handleClickClear },
                  this.getText("LT00000031", "Clear")),
              ),
            )
          )
        ),

        /* TABLE */
        m('.card',
          m('.card-body',
            m('.d-flex.justify-content-between.align-items-center.mb-2',
            m("span.fw-semibold", {style: {color: '#ff9800'}}, "*Note: Due to the large data volume, user can download up to 1 million records of raw data at a time."),
              m('.input-group.w-auto',
                m('button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split[type=button][data-bs-toggle=dropdown][arie-expanded=false]',
                  {
                    disabled: !(listReport.length > 0),
                  },
                  this.getText('LT00000492', 'Download')
                ),
                m('ul.dropdown-menu',
                  m('li',
                    m('a.dropdown-item[href="javascript:void(0);"]', {
                      onclick: (e) => {
                        e.preventDefault();
                        handleClickDownload(EXPORT_TYPE.SUMMARY);
                      }
                    },
                      this.getText('LT00008057', 'Summary Data')
                    )
                  ),
                  m('li',
                    m('a.dropdown-item[href="javascript:void(0);"]', {
                      class: totalResult.records > 1000000 ? 'disabled' : '',
                      onclick: (e) => {
                        e.preventDefault();
                        handleClickDownload(EXPORT_TYPE.RAW);
                      }
                    },
                      this.getText('LT00008050', 'Raw Data')
                    )
                  ),
                  m('li',
                    m('a.dropdown-item[href="javascript:void(0);"]', {
                      onclick: (e) => {
                        e.preventDefault();
                        handleClickDownload(EXPORT_TYPE.SALES_DATE_IMEI);
                      }
                    },
                      this.getText('LT00008058', 'Sales Date vs IMEI')
                    )
                  ),
                ),
              ),
            ),
            m('.row.g-2',
              m('.col-12',
                m('.table-responsive',
                  m('table.table.table-bordered',
                    m('thead',
                      m('tr.align-middle',
                        m('th.text-center', this.getText('LT00008059', 'Client Code')),
                        m('th.text-center', this.getText('LT00008060', 'Total Files')),
                        m('th.text-center', this.getText('LT00008061', 'Success Rate (%)')),
                        m('th.text-center', this.getText('LT00008062', 'Records')),
                        m('th.text-center', this.getText('LT00008063', 'Success')),
                        m('th.text-center', this.getText('LT00008064', 'Processed')),
                        m('th.text-center', this.getText('LT00008065', 'Errors')),
                        m('th.text-center', this.getText('LT00000108', 'Details')),
                      )
                    ),
                    m('tbody',
                      (listReport.length === 0) &&
                      m('tr',
                        m('td[colspan=9]', this.getText("EM00000141", "No records found."))
                      ),
                      listReport.length > 0 &&
                      listReport.map((row) => [
                        m(MonitoringReportFileContentDetailComponent,
                          {
                            data: row,
                            format: formatToPercentNumber,
                          }
                        ),
                      ]),
                    ),
                    m('tfoot',
                      m('tr.align-middle',
                        { style: { 'background-color': BG_COLOR_FOOT } },
                        m('th.text-center', this.getText('LT00000046', 'Total')),
                        m('td.text-center', totalResult.totalFiles),
                        m('td.text-center', totalResult.successRate),
                        m('td.text-center', totalResult.records),
                        m('td.text-center', totalResult.success),
                        m('td.text-center', totalResult.processed),
                        m('td.text-center', totalResult.errors),
                        m('td.text-center'),
                      )
                    )
                  )
                )
              ),
            )
          )
        ),

        this.getBaseViews()
      ]
    }
  }
}
